import { Leaderboard as LeaderboardProps, ProfileQueryOrderType } from '@web/graphql-components'
import { Leaderboard as PageLeaderboard } from '@web/components/page-components/Leaderboard'
import SubComponent from './SubComponent'
import { useQuery } from '@tanstack/react-query'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { useSearchParams } from 'next/navigation'
import { toSearchParams } from 'apps/fe-donation/utils'

const Leaderboard = (props: LeaderboardProps) => {
  const charityId = usePageStore((state) => state.charityId)
  const campaignId = usePageStore((state) => state.campaignId)
  const isLiveMode = usePageStore((state) => state.isLiveMode)
  const campaignDomain = usePageStore((state) => state.campaignDomain)
  const searchParams = useSearchParams()
  const query = searchParams?.toString() ? `?${searchParams.toString()}` : ''

  const { data: leaderboard = [], isPending } = useQuery({
    queryKey: ['profileData', campaignId],
    queryFn: () =>
      fetch(
        '/api/profiles?' +
          toSearchParams({
            charityId,
            campaignId,
            isLiveMode,
            orderBy: ProfileQueryOrderType.TotalDescending,
            isApprovedOnly: props.styles?.isApprovedOnly ?? false,
          }),
      )
        .then((res) => res.json())
        .catch(() => []),
    select: (data) =>
      data.map((x) => ({
        ...x,
        profileUrl: `${x.profileUrl}${query}`,
      })),
    enabled: !!charityId && !!campaignId,
  })

  return (
    <PageLeaderboard
      {...props}
      data={leaderboard}
      SubComponent={SubComponent}
      isLoading={isPending}
      registerUrl={`${campaignDomain}/register${query}`}
    />
  )
}

export default Leaderboard
